import React from 'react'
import { Card, Col, Button, OverlayTrigger, Popover} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import { MdAvTimer } from "react-icons/md";
import { RiDeleteBin6Line, RiDeleteBin2Line, RiPencilLine } from "react-icons/ri";


export default function Meditation(props) {
  const targetUrl = `/journal/add/${props._id}`;

  const imagesHeader = [
    "zen-gae256a556_640.jpg",
    "bamboo-gf128137f8_640.jpg",
    "buddha-g3b7b2af2a_640.jpg",
    "caucasus-ga0441eb1d_640.jpg",
    "floral-gcf51c8fd7_640.jpg",
    "buddha-g89c09065c_640.jpg",
    "japanese-gc53f64445_640.jpg",
    "buddhism-g8b7ba1046_640.jpg",
    "lotus-g4849b5994_640.jpg",
    "river-gbcbfd5298_640.jpg",
    "sea-g5335ffe08_640.jpg",
    "yoga-g02908cf02_640.jpg",
    "nature-g59dd27310_640.jpg"
  ];

  const getImage = () => {
    const imagesPath = "/images/";
    if(props.index > imagesHeader.length-1) {
      let index = Math.random() * (imagesHeader.length-1);
      return imagesPath + imagesHeader[index];
    }
    else 
      return imagesPath + imagesHeader[props.index]
  }

  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">Are you sure?</Popover.Header>
      <Popover.Body>
        It will be gone. <Button className="icons-buttons" variant="light" size="sm" onClick={() => {props.deleteMeditation(props._id)}}>Delete</Button>
      </Popover.Body>
    </Popover>
  );

  const popover1 = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">Cannot delete</Popover.Header>
      <Popover.Body>
        This meditation has records in your journal.
      </Popover.Body>
    </Popover>
  );

  
  return (
    <>
      
        <Col sm={12}>
        <Card border="danger" style={{ width: '100%' }}>
        <Link to={targetUrl} state={{meditationName: props.name, meditationDescription: props.description, meditationDuration: props.duration}}>
        <Card.Img variant="top" src={getImage()} className="bg-list img-fluid"/>
            <Card.Header><MdAvTimer/> {props.duration} mins</Card.Header></Link>
            <Card.Body>
            <Card.Title>{props.name}</Card.Title>
            {/* <Card.Text>
            {props.description}
            
            </Card.Text> */}
            <Button className="icons-buttons" variant="link" onClick={() => {props.editView(props._id); props.setModalShow(true)}}><RiPencilLine/></Button>
            
            { (props.meditation.journals.length === 0) ?

            <OverlayTrigger trigger="click" placement="right" overlay={popover} rootClose={true}>
                  <Button className="icons-buttons" variant="link" size="sm"><RiDeleteBin6Line/></Button>
            </OverlayTrigger>

             : 

              <OverlayTrigger trigger="click" placement="right" overlay={popover1} rootClose={true}>
                  <Button className="icons-buttons" variant="link text-muted" size="sm"><RiDeleteBin2Line/></Button>
            </OverlayTrigger>

            }
          
            </Card.Body>
        </Card>
        </Col>
      
      
    </>
  )
}
